<!-- @format -->

<ul
  #tabList
  class="nav nav-{{ type }}
    {{ wide && 'nav-wide-' + wide }}"
  [class.nav-invert]="invert"
  role="tablist">
  @for (tab of tabs; track tab; let index = $index) {
    <li role="presentation" [class.active]="isSelected(index)" [class.has-tail]="hasTail(tab)">
      <button
        (blur)="handleBlur($event)"
        (keydown)="handleKeyDown($event)"
        (keyup)="handleKeyUp($event, index)"
        role="tab"
        class="link-button"
        [attr.id]="tab.id ? tab.id : tab.title + '-tab'"
        [attr.data-cy]="tab.id"
        [attr.aria-selected]="isSelected(index)"
        [attr.tabindex]="isSelected(index) ? 0 : -1"
        (click)="switchTab(index)">
        {{ tab.title | translate }}
        @if (hasTail(tab)) {
          <span class="tail">{{ tab.tail }}</span>
        }
        @if (hasAmount(tab)) {
          <span> ({{ tab.amount }})</span>
        }
      </button>
    </li>
  }
</ul>
